import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-color-scheme: dark)';

function getSnapshot(): boolean {
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(QUERY).matches;
}

function subscribe(listener: () => void): () => void {
  if (typeof window.matchMedia !== 'function') {
    return () => {};
  }
  // FR-07: mění se za běhu bez reloadu, proto listener na `change`, ne jen jednorázové čtení.
  const mediaQueryList = window.matchMedia(QUERY);
  mediaQueryList.addEventListener('change', listener);
  return () => mediaQueryList.removeEventListener('change', listener);
}

// Předrenderování a hydratace (apps/landing, FR01 20261001_LandingPage/002_Marketing FR-03): na
// serveru `window` neexistuje a předrenderované HTML má neutrální stav "systém preferuje Light".
// React tuto hodnotu použije i při hydrataci a skutečnou hodnotu vykreslí hned po ní, takže nevznikne
// hydration mismatch. Aplikace používající createRoot server snapshot nikdy nečtou.
function getServerSnapshot(): boolean {
  return false;
}

/** FR-07 edge case: prohlížeč bez podpory `matchMedia` se vyhodnotí jako "systém preferuje Light". */
export function useSystemPrefersDark(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
